import React, { useState, Component } from 'react';
import { ArrowLeftIcon, CheckCircleIcon, LoaderIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const GetQuote = () => {
  const [formData, setFormData] = useState({
    name: '',
    businessName: '',
    email: '',
    phone: '',
    services: {
      customSoftware: false,
      webDevelopment: false,
      mobileDevelopment: false,
      securitySystems: false,
      cloudSolutions: false,
      dataManagement: false
    },
    description: ''
  });
  const [formStatus, setFormStatus] = useState({
    isSubmitting: false,
    isSubmitted: false,
    error: null
  });
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    if (type === 'checkbox') {
      setFormData(prev => ({
        ...prev,
        services: {
          ...prev.services,
          [name]: checked
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };
  const handleSubmit = async e => {
    e.preventDefault();
    // Basic validation
    if (!formData.name || !formData.email || !formData.phone || !formData.description) {
      setFormStatus({
        isSubmitting: false,
        isSubmitted: false,
        error: 'Please fill out all required fields'
      });
      return;
    }
    // Check if at least one service is selected
    const hasSelectedService = Object.values(formData.services).some(value => value);
    if (!hasSelectedService) {
      setFormStatus({
        isSubmitting: false,
        isSubmitted: false,
        error: 'Please select at least one service'
      });
      return;
    }
    // Set loading state
    setFormStatus({
      isSubmitting: true,
      isSubmitted: false,
      error: null
    });
    try {
      // Simulate sending data to server/email
      await new Promise(resolve => setTimeout(resolve, 1500));
      // In a real implementation, this is where you would send the data to am@binary-solutions.co.za
      // via a backend service or API
      // Set success state
      setFormStatus({
        isSubmitting: false,
        isSubmitted: true,
        error: null
      });
      // Reset form after success
      setFormData({
        name: '',
        businessName: '',
        email: '',
        phone: '',
        services: {
          customSoftware: false,
          webDevelopment: false,
          mobileDevelopment: false,
          securitySystems: false,
          cloudSolutions: false,
          dataManagement: false
        },
        description: ''
      });
    } catch (error) {
      setFormStatus({
        isSubmitting: false,
        isSubmitted: false,
        error: 'Failed to submit assessment request. Please try again.'
      });
    }
  };
  // For direct email option
  const composeEmail = () => {
    const selectedServices = Object.entries(formData.services).filter(([_, isSelected]) => isSelected).map(([service]) => service).join(', ');
    const subject = `Free Assessment Request from ${formData.name}`;
    const body = `
Name: ${formData.name}
Business: ${formData.businessName || 'N/A'}
Email: ${formData.email}
Phone: ${formData.phone}
Services: ${selectedServices || 'None selected'}
Project Description:
${formData.description}
    `;
    return `mailto:am@binary-solutions.co.za?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };
  return <main className="w-full bg-black text-white min-h-screen py-20" data-id="element-309">
      <div className="container mx-auto px-4" data-id="element-310">
        <Link to="/" className="inline-flex items-center text-gray-300 hover:text-red-600 mb-8 transition-colors" data-id="element-311">
          <ArrowLeftIcon className="h-5 w-5 mr-2" data-id="element-312" />
          Back to Home
        </Link>
        <div className="max-w-4xl mx-auto" data-id="element-313">
          <div className="text-center mb-12" data-id="element-314">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-315">
              Start a Free Assessment
            </h1>
            <div className="w-24 h-1 bg-red-600 mx-auto" data-id="element-316"></div>
            <p className="mt-6 text-gray-300 max-w-2xl mx-auto" data-id="element-317">
              Tell us about your project and we'll get back to you with a
              customized assessment for your specific needs.
            </p>
          </div>
          {formStatus.isSubmitted ? <div className="bg-gray-900 p-10 rounded-lg flex flex-col items-center justify-center text-center" data-id="element-318">
              <CheckCircleIcon className="h-20 w-20 text-red-500 mb-6" data-id="element-319" />
              <h2 className="text-2xl font-bold mb-4" data-id="element-320">
                Assessment Request Received!
              </h2>
              <p className="text-gray-300 mb-8 max-w-md" data-id="element-321">
                Thank you for your interest in Binary Solutions 101010. Our team
                will review your requirements and contact you shortly with a
                free assessment at{' '}
                <span className="text-red-500 font-medium" data-id="element-322">
                  am@binary-solutions.co.za
                </span>
                .
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-323">
                <Link to="/" className="bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-md font-medium transition-colors" data-id="element-324">
                  Return to Homepage
                </Link>
                <a href="mailto:am@binary-solutions.co.za" className="bg-gray-800 hover:bg-gray-700 text-white px-8 py-3 rounded-md font-medium transition-colors" data-id="element-325">
                  Email Us Directly
                </a>
              </div>
            </div> : <div className="bg-gray-900 p-8 rounded-lg" data-id="element-326">
              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-327">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-328">
                  <div data-id="element-329">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-330">
                      Your Name <span className="text-red-500" data-id="element-331">*</span>
                    </label>
                    <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent text-white" placeholder="John Doe" required data-id="element-332" />
                  </div>
                  <div data-id="element-333">
                    <label htmlFor="businessName" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-334">
                      Business Name
                    </label>
                    <input type="text" id="businessName" name="businessName" value={formData.businessName} onChange={handleChange} className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent text-white" placeholder="Your Company Ltd." data-id="element-335" />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-336">
                  <div data-id="element-337">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-338">
                      Email Address <span className="text-red-500" data-id="element-339">*</span>
                    </label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent text-white" placeholder="you@example.com" required data-id="element-340" />
                  </div>
                  <div data-id="element-341">
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-342">
                      Phone Number <span className="text-red-500" data-id="element-343">*</span>
                    </label>
                    <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent text-white" placeholder="+27 XX XXX XXXX" required data-id="element-344" />
                  </div>
                </div>
                <div data-id="element-345">
                  <label className="block text-sm font-medium text-gray-300 mb-3" data-id="element-346">
                    Services You're Interested In{' '}
                    <span className="text-red-500" data-id="element-347">*</span>
                  </label>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-348">
                    <div className="flex items-start" data-id="element-349">
                      <input type="checkbox" id="customSoftware" name="customSoftware" checked={formData.services.customSoftware} onChange={handleChange} className="h-5 w-5 mt-0.5 text-red-600 focus:ring-red-500 border-gray-600 rounded bg-gray-700" data-id="element-350" />
                      <label htmlFor="customSoftware" className="ml-2 text-gray-300" data-id="element-351">
                        Custom Software Development
                      </label>
                    </div>
                    <div className="flex items-start" data-id="element-352">
                      <input type="checkbox" id="webDevelopment" name="webDevelopment" checked={formData.services.webDevelopment} onChange={handleChange} className="h-5 w-5 mt-0.5 text-red-600 focus:ring-red-500 border-gray-600 rounded bg-gray-700" data-id="element-353" />
                      <label htmlFor="webDevelopment" className="ml-2 text-gray-300" data-id="element-354">
                        Website Development
                      </label>
                    </div>
                    <div className="flex items-start" data-id="element-355">
                      <input type="checkbox" id="mobileDevelopment" name="mobileDevelopment" checked={formData.services.mobileDevelopment} onChange={handleChange} className="h-5 w-5 mt-0.5 text-red-600 focus:ring-red-500 border-gray-600 rounded bg-gray-700" data-id="element-356" />
                      <label htmlFor="mobileDevelopment" className="ml-2 text-gray-300" data-id="element-357">
                        Mobile App Development
                      </label>
                    </div>
                    <div className="flex items-start" data-id="element-358">
                      <input type="checkbox" id="securitySystems" name="securitySystems" checked={formData.services.securitySystems} onChange={handleChange} className="h-5 w-5 mt-0.5 text-red-600 focus:ring-red-500 border-gray-600 rounded bg-gray-700" data-id="element-359" />
                      <label htmlFor="securitySystems" className="ml-2 text-gray-300" data-id="element-360">
                        Smart Security Systems
                      </label>
                    </div>
                    <div className="flex items-start" data-id="element-361">
                      <input type="checkbox" id="seecrypt" name="seecrypt" checked={formData.services.seecrypt} onChange={handleChange} className="h-5 w-5 mt-0.5 text-red-600 focus:ring-red-500 border-gray-600 rounded bg-gray-700" data-id="element-362" />
                      <label htmlFor="seecrypt" className="ml-2 text-gray-300" data-id="element-363">
                        SEECRYPT Secure Communications
                      </label>
                    </div>
                    <div className="flex items-start" data-id="element-364">
                      <input type="checkbox" id="cloudSolutions" name="cloudSolutions" checked={formData.services.cloudSolutions} onChange={handleChange} className="h-5 w-5 mt-0.5 text-red-600 focus:ring-red-500 border-gray-600 rounded bg-gray-700" data-id="element-365" />
                      <label htmlFor="cloudSolutions" className="ml-2 text-gray-300" data-id="element-366">
                        Cloud Solutions
                      </label>
                    </div>
                    <div className="flex items-start" data-id="element-367">
                      <input type="checkbox" id="dataManagement" name="dataManagement" checked={formData.services.dataManagement} onChange={handleChange} className="h-5 w-5 mt-0.5 text-red-600 focus:ring-red-500 border-gray-600 rounded bg-gray-700" data-id="element-368" />
                      <label htmlFor="dataManagement" className="ml-2 text-gray-300" data-id="element-369">
                        Data Management
                      </label>
                    </div>
                  </div>
                </div>
                <div data-id="element-370">
                  <label htmlFor="description" className="block text-sm font-medium text-gray-300 mb-1" data-id="element-371">
                    Project Description <span className="text-red-500" data-id="element-372">*</span>
                  </label>
                  <textarea id="description" name="description" rows={6} value={formData.description} onChange={handleChange} className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-transparent text-white" placeholder="Please describe your project, requirements, and any specific needs you have..." required data-id="element-373"></textarea>
                </div>
                <p className="text-gray-400 text-sm" data-id="element-374">
                  Your assessment request will be sent to{' '}
                  <span className="text-red-500" data-id="element-375">
                    am@binary-solutions.co.za
                  </span>
                </p>
                {formStatus.error && <div className="text-red-500 text-sm bg-red-900 bg-opacity-30 p-3 rounded" data-id="element-376">
                    {formStatus.error}
                  </div>}
                <div className="flex flex-col sm:flex-row gap-4" data-id="element-377">
                  <button type="submit" disabled={formStatus.isSubmitting} className="flex-1 bg-red-600 hover:bg-red-700 text-white font-medium py-3 px-4 rounded-md transition-colors flex items-center justify-center disabled:bg-red-800 disabled:cursor-not-allowed" data-id="element-378">
                    {formStatus.isSubmitting ? <>
                        <LoaderIcon className="animate-spin -ml-1 mr-2 h-5 w-5" data-id="element-379" />
                        Submitting...
                      </> : 'Start Free Assessment'}
                  </button>
                  <a href={composeEmail()} className="flex-1 sm:flex-initial bg-gray-800 hover:bg-gray-700 text-white font-medium py-3 px-4 rounded-md transition-colors flex items-center justify-center" data-id="element-380">
                    Email Directly
                  </a>
                </div>
              </form>
            </div>}
        </div>
      </div>
    </main>;
};